import React from "react";
import styled from "styled-components";
import TermConditionC from "../../Components/TermConditions/TermCondition";
import { useTheme } from "@mui/material/styles";

function TermCondition() {
  const theme = useTheme();
  console.log("theme ==> ", theme);
  
  const Body = styled.div`
    min-height: 100vh;
    padding: 60px 5% 60px;
    
    @media (max-width: 768px) {
      padding: 40px 4% 30px;
    }
    
    @media (max-width: 480px) {
      padding: 20px 3% 20px;
    }
  `;

  const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    
    @media (max-width: 768px) {
      border-radius: 15px;
    }
  `;

  const Header = styled.div`
    background: #f8f9fa;
    color: ${theme.palette.header.main};
    padding: 40px 50px;
    text-align: center;
    border-bottom: 1px solid #e9ecef;
    
    @media (max-width: 768px) {
      padding: 30px 30px;
    }
    
    @media (max-width: 480px) {
      padding: 25px 20px;
    }
  `;

  const Title = styled.h1`
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0 0 10px 0;
    letter-spacing: -0.02em;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
    
    @media (max-width: 480px) {
      font-size: 1.75rem;
    }
  `;

  const Subtitle = styled.p`
    font-size: 1.1rem;
    opacity: 0.9;
    margin: 0;
    font-weight: 300;
    
    @media (max-width: 768px) {
      font-size: 1rem;
    }
  `;

  const ContentWrapper = styled.div`
    padding: 50px;
    
    @media (max-width: 768px) {
      padding: 30px;
    }
    
    @media (max-width: 480px) {
      padding: 20px;
    }
  `;

  const StyledTermConditionC = styled(TermConditionC)`
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    line-height: 1.6;
    color: #333;
    
    h2 {
      color: ${theme.palette.primary.main};
      font-size: 1.5rem;
      font-weight: 600;
      margin: 30px 0 15px 0;
      border-bottom: 2px solid ${theme.palette.primary.light};
      padding-bottom: 8px;
      
      @media (max-width: 768px) {
        font-size: 1.3rem;
        margin: 25px 0 12px 0;
      }
    }
    
    h3 {
      color: #555;
      font-size: 1.2rem;
      font-weight: 600;
      margin: 25px 0 12px 0;
      
      @media (max-width: 768px) {
        font-size: 1.1rem;
        margin: 20px 0 10px 0;
      }
    }
    
    p {
      margin: 0 0 15px 0;
      font-size: 1rem;
      
      @media (max-width: 768px) {
        font-size: 0.95rem;
        margin: 0 0 12px 0;
      }
    }
    
    ul, ol {
      margin: 15px 0;
      padding-left: 25px;
      
      @media (max-width: 768px) {
        margin: 12px 0;
        padding-left: 20px;
      }
    }
    
    li {
      margin: 8px 0;
      line-height: 1.5;
      
      @media (max-width: 768px) {
        margin: 6px 0;
      }
    }
    
    strong {
      color: ${theme.palette.primary.main};
      font-weight: 600;
    }
    
    a {
      color: ${theme.palette.primary.main};
      text-decoration: none;
      border-bottom: 1px solid transparent;
      transition: border-bottom 0.2s ease;
      
      &:hover {
        border-bottom: 1px solid ${theme.palette.primary.main};
      }
    }
  `;

  const Footer = styled.div`
    background: #f8f9fa;
    padding: 30px 50px;
    text-align: center;
    border-top: 1px solid #e9ecef;
    
    @media (max-width: 768px) {
      padding: 25px 30px;
    }
    
    @media (max-width: 480px) {
      padding: 20px 20px;
    }
  `;

  const LastUpdated = styled.p`
    color: #6c757d;
    font-size: 0.9rem;
    margin: 0;
    
    @media (max-width: 768px) {
      font-size: 0.85rem;
    }
  `;

  return (
    <Body>
      <Container>
        <Header>
          <Title>Terms and Conditions</Title>
          <Subtitle>Please read these terms carefully before using our services</Subtitle>
        </Header>
        
        <ContentWrapper>
          <StyledTermConditionC />
        </ContentWrapper>
        
        <Footer>
          <LastUpdated>Last updated: {new Date().toLocaleDateString()}</LastUpdated>
        </Footer>
      </Container>
    </Body>
  );
}

export default TermCondition;

